import * as ProgressPrimitive from '@radix-ui/react-progress'
import * as React from 'react'

import { cn } from '@sparkai/utils'

export type ProgressProps = React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
  className?: string
  indicatorClassname?: string
  value: number
  text?: string
}

export const Progress = React.forwardRef<React.ElementRef<typeof ProgressPrimitive.Root>, ProgressProps>(
  ({ className, indicatorClassname, value, text, ...props }, ref) => (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        'relative flex h-8 w-full items-center overflow-hidden rounded-[4px] border border-gray-200 bg-white',
        className
      )}
      {...props}
    >
      {text && <span className='absolute left-3 z-40 text-sm leading-5 font-semibold'>{text}</span>}
      <ProgressPrimitive.Indicator
        className={cn('h-full w-full flex-1 bg-green-400 transition-all', indicatorClassname)}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  )
)

Progress.displayName = ProgressPrimitive.Root.displayName
